"use client";
import { createContext } from "react";
import { type RouterOutputs } from "@introw/api/types";

export type CurrentRoom =
  | (RouterOutputs["rooms"]["details"] & {
      roomVisitor?: RouterOutputs["rooms"]["visitorDetails"]["roomVisitor"];
      currentStage: string;
      isPreview?: boolean;
      isEmbedded?: boolean;
      forceFullLayout?: boolean;
    })
  | null;

export const RoomContext = createContext<CurrentRoom>(null);

export const RoomContextProvider = ({ children, room }: { room: CurrentRoom; children: React.ReactNode }) => {
  return <RoomContext.Provider value={room}>{children}</RoomContext.Provider>;
};
